'use client'

import { ThemeProvider as NextThemeProvider } from 'next-themes'
import { ReactNode, useEffect } from 'react'
import { useThemeStore } from '@/stores/theme-store'
import { applyTheme } from '@/lib/apply-theme'

interface ThemeProviderProps {
  children: ReactNode
  [key: string]: any
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const { colorScheme, darkMode } = useThemeStore()

  // Apply theme when colorScheme or darkMode changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Apply the theme
      applyTheme(colorScheme)
      
      // Apply dark mode
      if (darkMode) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
      
      // Add font classes to root element
      document.documentElement.classList.add('font-open-sans')
      
      // Also add the theme as a class (belt and suspenders approach)
      document.documentElement.classList.add(colorScheme)
    }
  }, [colorScheme, darkMode])

  return (
    <NextThemeProvider
      attribute="class"
      value={{
        dark: 'dark',
        light: 'light',
        system: 'system'
      }}
      defaultTheme="system"
      enableSystem
      enableColorScheme
      disableTransitionOnChange={false}
      {...props}
    >
      {children}
    </NextThemeProvider>
  )
}